import { getManagePaymentStatus } from "./getManagePaymentStatus";

export const getManagePaymentStatusText = (payment) => {
  const status = getManagePaymentStatus(payment);
  if (status === "problem") return "Expired";
  else if (status === "risk") return "Expiring Soon";
  else return "Active";
};
